import React,{Component,Fragment} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {actionCreators} from '../../actions/tagDataAction';
import {actionCreators as filterActions} from '../../actions/searchBarActions';
import {withRouter} from 'react-router-dom';
import FilterHeader from './FilterHeaders';
import searchIcon from '../img/search-icon.png';
import './Searchbar2.scss';
import APPCONST from '../../constants/constants';

/**
 * This is the searchbar component that displays the filter items and searchbar.
 * 
 * It is a complete re-write of the prior searchbar component, please refer to ACH-328
 * for more details. 
 */
class SearchBar extends Component{
    constructor(props){
        super(props);
        this.state={
			filters:false,
            searchQ:this.props.filterData.searchQuery || ''
        }
	}
	
	componentDidUpdate(prevProps){
		if(this.props.filterData.searchQuery!==prevProps.filterData.searchQuery)
			this.setState({
				searchQ:this.props.filterData.searchQuery
			})
	}

    handleMenuExpand(e){
        this.props.setCurrentOpen(e);
    }

    handleItemSelect(e){
		this.props.addSearchFilter(e);
		this.props.history.push('/filter/')
    }

    handleItemDeselect(e){
        this.props.removeSearchFilter(e);
    }

	handleKeyPress(e){
		if(e.key==='Enter')
			this.searchButtonClick();
	}

	toggleFilters(toggle){
		let open=(toggle!==undefined?toggle:this.state.filters===false);
		if(this.state.filters!==open)
			this.setState({
				filters:open
			});
	}

    generateFilterHeaders(){
        if(this.props.tagData.filter_tags){
            let headers=[];
            this.props.tagData.filter_tags.forEach((element,i)=>{
                headers.push(
					<FilterHeader key={i}
						data={element} 
                        filters={this.props.filterData.filters}
						current={this.props.filterData.currentOpen} 
						handleOnClick={e=>this.handleMenuExpand(e)} 
						onItemSelect={this.handleItemSelect.bind(this)}
						onItemDeselect={this.handleItemDeselect.bind(this)} 
					/>);
            });
            return headers;
        }
    }

    searchButtonClick(){
		this.props.toggle_filters(false);
        this.props.addSearch(this.state.searchQ);
        this.props.history.push('/filter/');
	}
	
	clearButtonClick(){
		this.toggleFilters(false);
		this.props.removeAllFilters();
		this.props.toggle_filters(false);
	}

    handleChange(e){
        this.setState({searchQ: e.target.value});
    }

    render(){
		if(this.props.tagData.tags===undefined){
			this.props.getTags();
			return <React.Fragment/>;
		}

        return (
			<Fragment>
				<div className={['filterbar-container',this.props.filter_open===true?'filterbar-open':null].join(' ')}>
					<div className="region-toggle" onClick={this.props.toggle_region}>
						{window.global.content_hub.region===APPCONST.WEST?'Go to Eastern Post':'Go to Western Post'}
					</div>
					<div className="searchbar-container">
						<div className="searchbox">
							<label htmlFor="search-bar-input-m" style={{display:'none'}}>search label</label>
							<input
								id="search-bar-input-m"
								type="text"
								placeholder="Search The Farm Post"
								name="search"
								className="browser-default"
								data-action="add"
								data-label="search"
								value={this.state.searchQ}
								onKeyPress={(e)=>this.handleKeyPress(e)}
								onChange={(e)=>{this.handleChange(e)}}
							/>
							<button type="submit" onClick={this.searchButtonClick.bind(this)}>
								<img alt="search-icon" src={searchIcon} />
							</button>
						</div>
						<div className="mobileFilterButton clear" onClick={()=>this.clearButtonClick()}>Clear</div>
					</div>
					<div className="categories-container">
						<div className={['drop-cat-container',(this.state.filters!==true?'hide-filter-items':'')].join(' ')}>
							<div className="mobileFilterActions">
								<div className="mobileFilterButton more" onClick={()=>this.toggleFilters()}>{this.state.filters===true?'Hide Filters':'More Filters'}</div>
								{this.state.filters===true
									?<React.Fragment>
										<div style={{width:'100%'}}/>
										<div className="mobileFilterButton apply" onClick={()=>this.props.toggle_filters(false)}>Apply</div>
									</React.Fragment>
									:null}
							</div>
							{this.generateFilterHeaders()}
						</div>
					</div>
				</div>
           </Fragment>
		);
	}
}

export default connect(
    (state) => {
      const { tagData, filterData } = state;
      return { tagData, filterData };
    },
    (dispatch) =>
      bindActionCreators({ ...actionCreators, ...filterActions }, dispatch)
  )(withRouter(SearchBar));
  